import { type FieldContentsData } from 'javascripts/shared-types';
import terminology from 'javascripts/terminology';
import { ProgramIncrementField } from './ProgramIncrementField';

export class ProgramIncrementIcon extends ProgramIncrementField {
  get title() {
    return `${terminology('Program increment')} icon`;
  }

  exampleContents(): FieldContentsData {
    return {
      icon: {
        name: 'fa-regular fa-arrows-spin',
        color: 'var(--aha-purple-300)',
      },
    };
  }

  contentsForRecord(record): FieldContentsData {
    let { programIncrement } = record;

    if (programIncrement) {
      return {
        icon: {
          name: 'fa-regular fa-arrows-spin',
          color: 'var(--aha-purple-300)',
        },
      };
    }

    return {};
  }
}
